<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="6" lg="3">
      <FilterSearch :fetchData="fetchAppointmentsAsAdmin" inner-icon="mdi-magnify" />
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="3">
      <FilterAutocomplete
        :item-text="'name'"
        :loading="isAdminAppointmentTypeLoading"
        :label="$t('appointment.filters.type')"
        :fetchData="fetchAppointmentsAsAdmin"
        :items="appointmentTypes"
        type="serviceType"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterDate :fetchData="fetchAppointmentsAsAdmin" :dateRange="true" defaultRange="recent" ref="dateFilter" />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('appointment.filters.status')"
        :fetchData="fetchAppointmentsAsAdmin"
        :disabled="hostPendingAppointmentFilter"
        :items="status"
        type="status"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterHost
        :label="$t('appointment.filters.hosts')"
        :fetchData="fetchAppointmentsAsAdmin"
        multiple
        :disabled="hostPendingAppointmentFilter"
        value="id"
        type="hostIds"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="4">
      <FilterCity
        :fetchData="fetchAppointmentsAsAdmin"
        :multiple="true"
        type="cityIds"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="4">
      <FilterAutocomplete
        @filterSetted="handleRealEstateFilterSetted"
        :label="$t('genericFilters.label.realEstate')"
        :no-data-text="$t('appointment.filters.typeToSearchRealEstate')"
        :fetchData="fetchAppointmentsAsAdmin"
        :asyncSearch="searchCustomers"
        :loading="isCustomersLoading"
        :items="customers"
        prepend-inner-icon="mdi-magnify"
        type="realEstateId"
        value="id"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('appointment.filters.branch')"
        :fetchData="fetchAppointmentsAsAdmin"
        :asyncSearch="fetchBranchesAsAdmin"
        :disabled="disableBranchFilter"
        :items="branches"
        type="branchId"
        value="id"
        ref="branchFilter"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('appointment.filters.subscriptionType')"
        :fetchData="fetchAppointmentsAsAdmin"
        :items="subscriptionTypes"
        type="subscriptionType"
        value="value"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('appointment.filters.confirmed')"
        :fetchData="fetchAppointmentsAsAdmin"
        :items="confirmedOptions"
        type="confirmed"
        value="value"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="3">
      <FilterAutocomplete
        :label="$t('appointment.filters.confirmationEmailSent')"
        :fetchData="fetchAppointmentsAsAdmin"
        :items="confirmationEmailSentOptions"
        type="confirmationEmailSent"
        value="value"
      />
    </v-col>
    <!-- TODO: Add worker type to the appointment list filters -->
    <!-- <v-col cols="12" sm="12" md="4" lg="2">
      <FilterSelect
        :label="$t('appointment.filters.workerType')"
        :fetchData="fetchAppointmentsAsAdmin"
        :items="workerType"
        type="workerType"
        item-text="label"
        item-value="value"
        multiple
      />
    </v-col> -->
  </v-row>
</template>

<script>
import FilterSearch from '@/components/filters/FilterSearch'
import FilterDate from '@/components/filters/FilterDate'
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'
import RealEstateSelectFilter from '@/components/realEstate/RealEstateSelectFilter'
import FilterHost from '@/components/filters/FilterHost'
import FilterCity from '@/components/filters/FilterCity'
import FilterSelect from '@/components/filters/FilterSelect'

import { mapGetters, mapActions } from 'vuex'
import { workerType } from '@/util/enums'

import store from '@/store'

export default {
  name: 'AdminAppointmentListFilters',
  components: {
    FilterAutocomplete,
    FilterSearch,
    FilterDate,
    RealEstateSelectFilter,
    FilterHost,
    FilterCity,
    FilterSelect,
  },

  computed: {
    ...mapGetters([
      'isAdminAppointmentTypeLoading',
      'isCustomersLoading',
      'appointmentTypes',
      'customers',
      'branches',
      'cities',
    ]),
    hostPendingAppointmentFilter() {
      if (this.hostId) {
        return true
      }

      return false
    },
  },

  methods: {
    ...mapActions([
      'fetchBranchesAsAdmin',
      'fetchAppointmentTypeAsAdmin',
      'fetchAppointmentsAsAdmin',
      'fetchCitiesAsAdmin',
      'searchCustomers',
    ]),

    handleRealEstateFilterSetted() {
      store.getters.filters.branchId = null;
      this.$refs.branchFilter.clearFilter();
      if (store.getters.filters && store.getters.filters.realEstateId) {
        this.disableBranchFilter = false;
        this.fetchBranchesAsAdmin();
      } else {
        this.disableBranchFilter = true;
      }
    }
  },

  data() {
    return {
      status: [
        { value: 'OPEN', name: this.$t('appointment.status.OPEN') },
        { value: 'SCHEDULED', name: this.$t('appointment.status.SCHEDULED') },
        { value: 'DONE', name: this.$t('appointment.status.DONE') },
        { value: 'CANCELED', name: this.$t('appointment.status.CANCELED') },
        { value: 'DRAFT', name: this.$t('appointment.status.DRAFT') },
        { value: 'REJECTED', name: this.$t('appointment.status.REJECTED') },
      ],
      subscriptionTypes: [
        { name: this.$t('realEstate.subscriptionTypes.TRIAL'), value: 'TRIAL' },
        {
          name: this.$t('realEstate.subscriptionTypes.SINGLE_PURCHASE'),
          value: 'SINGLE_PURCHASE',
        },
        {
          name: this.$t('realEstate.subscriptionTypes.PREPAID'),
          value: 'PREPAID',
        },
        {
          name: this.$t('realEstate.subscriptionTypes.PREPAID_SAAS'),
          value: 'PREPAID_SAAS',
        },
        {
          name: this.$t('realEstate.subscriptionTypes.POSTPAID'),
          value: 'POSTPAID',
        },
        {
        name: this.$t('realEstate.subscriptionTypes.POSTPAID_SAAS'),
          value: 'POSTPAID_SAAS',
        },
        {
          name: this.$t('realEstate.subscriptionTypes.SUBSCRIPTION_TRIMESTER'),
          value: 'SUBSCRIPTION_TRIMESTER',
        },
        {
          name: this.$t('realEstate.subscriptionTypes.SUBSCRIPTION_SEMESTER'),
          value: 'SUBSCRIPTION_SEMESTER',
        },
        {
          name: this.$t('realEstate.subscriptionTypes.SUBSCRIPTION_NONAMESTER'),
          value: 'SUBSCRIPTION_NONAMESTER',
        },
        {
          name: this.$t('realEstate.subscriptionTypes.SUBSCRIPTION_YEAR'),
          value: 'SUBSCRIPTION_YEAR',
        },
        {
          name: this.$t('realEstate.subscriptionTypes.SUBSCRIPTION_LIFELONG'),
          value: 'SUBSCRIPTION_LIFELONG',
        },
      ],
      confirmedOptions: [
        {
          name: this.$t('appointment.filters.confirmed'),
          value: true
        },
        {
          name: this.$t('appointment.filters.notConfirmed'),
          value: false
        },
      ],
      confirmationEmailSentOptions: [
        {
          name: this.$t('appointment.filters.sent'),
          value: true
        },
        {
          name: this.$t('appointment.filters.notSent'),
          value: false
        },
      ],
      hostId: this.$router.currentRoute.params.hostId,
      disableBranchFilter: true,
      workerType: workerType,
    }
  },

  mounted() {
    this.fetchAppointmentTypeAsAdmin()

    this.$nextTick(() => {
      this.$refs.dateFilter?.selectDate('recent', 60)
    })
  },
}
</script>
